var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSleepOptimisation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Smart-Watch-Square-Sleep-Alternate--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Smart Watch Square Sleep Alternate Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21 6a3 3 0 0 0 -3 -3h-1.08a0.25 0.25 0 0 1 -0.24 -0.18L16 0.36a0.5 0.5 0 0 0 -0.5 -0.36h-7a0.5 0.5 0 0 0 -0.5 0.36l-0.7 2.46a0.25 0.25 0 0 1 -0.22 0.18H6a3 3 0 0 0 -3 3v12a3 3 0 0 0 3 3h1.08a0.26 0.26 0 0 1 0.24 0.18L8 23.64a0.5 0.5 0 0 0 0.5 0.36h7a0.5 0.5 0 0 0 0.48 -0.36l0.7 -2.46a0.26 0.26 0 0 1 0.24 -0.18H18a3 3 0 0 0 3 -3Zm-2 12a1 1 0 0 1 -1 1H6a1 1 0 0 1 -1 -1V6a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 7.78A1.51 1.51 0 0 0 13.69 7H10.1a1 1 0 0 0 0 2h2.24a0.25 0.25 0 0 1 0.22 0.13 0.23 0.23 0 0 1 0 0.25l-3.33 5.33a1.48 1.48 0 0 0 0 1.52 1.5 1.5 0 0 0 1.27 0.77h3.6a1 1 0 1 0 0 -2h-2.25a0.26 0.26 0 0 1 -0.22 -0.13 0.25 0.25 0 0 1 0 -0.25L15 9.29a1.49 1.49 0 0 0 0 -1.51Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSleepOptimisation);
export default ForwardRef;